import { render, staticRenderFns } from "./book.vue?vue&type=template&id=098dcf0e&"
import script from "./book.vue?vue&type=script&lang=ts&"
export * from "./book.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports